import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

function List({ title, rows, testid, render }) {
  if (!rows?.length) return null;
  return (
    <div data-testid={testid}><p className="text-xs font-semibold text-slate-600 mb-1">{title} ({rows.length})</p>
      <ul className="text-sm text-slate-700 space-y-0.5">{rows.map((r, i) => <li key={i}>{r.person} <span className="text-xs text-slate-400">{r.person_number}</span> · {r.date} · {r.title} {render ? `— ${render(r)}` : ""}</li>)}</ul></div>
  );
}

export function ReconcileDates({ org }) {
  const [rep, setRep] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (mode) => {
    if (mode === "apply" && !window.confirm(`Fill ${rep.populated.length} blank Overview interview dates? Existing dates are never changed.`)) return;
    setBusy(true);
    try { const r = (await api.post(`/admin/interview-import/reconcile-dates/${mode}`, { organization_id: org })).data; setRep(r); if (mode === "apply") toast.success(`${r.populated.length} Overview dates filled`); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const months = rep ? rep.months_after : {};
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 space-y-3" data-testid="iv-reconcile">
      <div><h2 className="font-semibold text-slate-900">Sync Overview interview dates</h2>
        <p className="text-xs text-slate-500">Fills blank First/Final Interview Dates from imported interviews explicitly titled First, Initial or Final, already held. Generic, cancelled, future and same-day duplicate entries are flagged, not used. Existing dates are never overwritten.</p></div>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={() => run("preview")} disabled={busy || !org} data-testid="iv-reconcile-preview">Check dates</Button>
        {rep && !rep.applied && <Button size="sm" onClick={() => run("apply")} disabled={busy || !rep.populated.length} className="bg-[#006090] hover:bg-[#004E75]" data-testid="iv-reconcile-apply">Fill {rep.populated.length} dates</Button>}
      </div>
      {rep && (
        <div className="space-y-3">
          <p className="text-sm text-slate-700" data-testid="iv-reconcile-summary">Interviews {rep.year} YTD: {rep.ytd_before} → {rep.ytd_after}{rep.applied ? "" : " (after filling)"} · Filled {rep.populated.length} · Kept existing {rep.preserved.length} · Conflicts {rep.conflicts.length} · Flagged {rep.flagged.length}</p>
          <p className="text-xs text-slate-500" data-testid="iv-reconcile-months">By month: {Object.entries(months).map(([m, n]) => `${m} ${n}`).join(" · ") || "none"}</p>
          <List title={rep.applied ? "Filled" : "Will fill"} rows={rep.populated} testid="iv-rc-populated" render={(r) => r.label} />
          <List title="Conflicts — review, not changed" rows={rep.conflicts} testid="iv-rc-conflicts" render={(r) => r.reason} />
          <List title="Existing date kept (earlier or same)" rows={rep.preserved} testid="iv-rc-preserved" render={(r) => `${r.label} on file ${r.existing}`} />
          <List title="Flagged — not used" rows={rep.flagged} testid="iv-rc-flagged" render={(r) => r.reason} />
        </div>)}
    </div>
  );
}
